import { inject } from '@angular/core';
import { type HttpInterceptorFn } from '@angular/common/http';

import { withBearerToken } from '../utils/with-bearer-token';

import { REQUIRES_AUTH } from '../tokens';

import { TokenStorage } from '@core/auth';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.context.get(REQUIRES_AUTH)) {
    return next(request);
  }

  const token = inject(TokenStorage).get();

  if (token) {
    return next(withBearerToken(request, token.key));
  }

  return next(request);
};
